// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roq-chat-window__content__active-uploads {
  align-items: center;
  background-color: var(--color-background);
  border-bottom: var(--border-pale);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  inset: 0 0 auto;
  justify-content: center;
  padding: var(--spacing-small);
  position: absolute;
  z-index: var(--z-modals);
}

/* Single File Progress Card */
.roq-file-active-upload__list-item {
  align-items: center;
  display: flex;
  gap: var(--spacing-small);
  padding: var(--spacing-small);
}

/* File icon */
.roq-file-active-upload__file-icon-column {
  align-items: center;
  color: var(--color-icons-inactive);
  display: flex;
  justify-content: center;
}

/* Upload details */
.roq-file-active-upload__details-column {
  flex-grow: 1;
}

/* File name, size, close btn */
.roq-file-active-upload__file-info-row {
  display: flex;
  justify-content: space-between;
}

.roq-file-active-upload__file-name-and-size-column {
  width: var(--size-progress-bar);
}

.roq-file-active-upload__file-name {
  font-weight: var(--font-semibold);
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.roq-file-active-upload__file-size-row {
  font-size: var(--font-sm);
  font-style: italic;
}

/* Close btn */
.roq-icon-button__icon-wrapper {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

/* Progress bar and percentage */
.roq-file-active-upload__progress-row {
  display: flex;
}

.roq-file-active-upload__progress-bar-row progress {
  border: none;
  border-radius: var(--border-radius-tiny);
  height: 0.5rem;
  vertical-align: middle;
  width: var(--size-progress-bar);
}

.roq-file-active-upload__progress-bar-row progress::-moz-progress-bar {
  background-color: var(--color-primary-light);
  border-radius: var(--border-radius-tiny);
}

.roq-file-active-upload__progress-bar-row progress::-webkit-progress-bar {
  background-color: var(--color-border-dark);
  border-radius: var(--border-radius-tiny);
}

.roq-file-active-upload__progress-bar-row progress::-webkit-progress-value {
  background-color: var(--color-primary-light);
  border-radius: var(--border-radius-tiny);
}

/* Percentage */
.roq-file-active-upload__progress-percentage-column {
  margin-left: var(--spacing-tiny);
  /* 4 chars "100%" */
  min-width: 4ch;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_window-file-upload-progress.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,cAAc;EACd,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".roq-chat-window__content__active-uploads {\n  align-items: center;\n  background-color: var(--color-background);\n  border-bottom: var(--border-pale);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-small);\n  inset: 0 0 auto;\n  justify-content: center;\n  padding: var(--spacing-small);\n  position: absolute;\n  z-index: var(--z-modals);\n}\n\n/* Single File Progress Card */\n.roq-file-active-upload__list-item {\n  align-items: center;\n  display: flex;\n  gap: var(--spacing-small);\n  padding: var(--spacing-small);\n}\n\n/* File icon */\n.roq-file-active-upload__file-icon-column {\n  align-items: center;\n  color: var(--color-icons-inactive);\n  display: flex;\n  justify-content: center;\n}\n\n/* Upload details */\n.roq-file-active-upload__details-column {\n  flex-grow: 1;\n}\n\n/* File name, size, close btn */\n.roq-file-active-upload__file-info-row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.roq-file-active-upload__file-name-and-size-column {\n  width: var(--size-progress-bar);\n}\n\n.roq-file-active-upload__file-name {\n  font-weight: var(--font-semibold);\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.roq-file-active-upload__file-size-row {\n  font-size: var(--font-sm);\n  font-style: italic;\n}\n\n/* Close btn */\n.roq-icon-button__icon-wrapper {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n}\n\n/* Progress bar and percentage */\n.roq-file-active-upload__progress-row {\n  display: flex;\n}\n\n.roq-file-active-upload__progress-bar-row progress {\n  border: none;\n  border-radius: var(--border-radius-tiny);\n  height: 0.5rem;\n  vertical-align: middle;\n  width: var(--size-progress-bar);\n}\n\n.roq-file-active-upload__progress-bar-row progress::-moz-progress-bar {\n  background-color: var(--color-primary-light);\n  border-radius: var(--border-radius-tiny);\n}\n\n.roq-file-active-upload__progress-bar-row progress::-webkit-progress-bar {\n  background-color: var(--color-border-dark);\n  border-radius: var(--border-radius-tiny);\n}\n\n.roq-file-active-upload__progress-bar-row progress::-webkit-progress-value {\n  background-color: var(--color-primary-light);\n  border-radius: var(--border-radius-tiny);\n}\n\n/* Percentage */\n.roq-file-active-upload__progress-percentage-column {\n  margin-left: var(--spacing-tiny);\n  /* 4 chars \"100%\" */\n  min-width: 4ch;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
